// extracted by mini-css-extract-plugin
export var heroImage = "_dt-1";
export var modal = "_dt-0";